import merge from "lodash.merge";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { ProposedProjectController } from "services/proposedProject/controller";
import { FormRenderer, useAccordionWizard } from "stories";
import { AccordionForm } from "stories/components/accordionForm";
import { useFileUpload } from "utils/customHooks/useFileUpload";
import { useToast } from "utils/customHooks/useToast";
import { removeEmptyValues } from "../../../loanDetails/elements/borrower/LoanDetailsBorrower";
import { proposedOverviewFields } from "./form-fields";

const proposedProjectController = ProposedProjectController();

const getProposedOverviewModel = () => ({
  address: "",
  city: "",
  country: "",
  current_zoning_specification: "",
  fsr_far: "",
  google_map_url: "",
  gross_buildable_area: "",
  gross_floor_area: "",
  land_title_document_filename: null,
  legal_description: "",
  municipality_servicing_agreement_description: "",
  net_floor_area: "",
  new_fsr_far: "",
  new_gross_buildable_area: "",
  new_gross_floor_area: "",
  new_net_floor_area: "",
  new_permitted_density: "",
  new_zoning_specifications: "",
  off_site_land_servicing_to_be_built: {
    cable: false,
    fire: false,
    gas: false,
    other: false,
    power: false,
    sewage: false,
    storm: false,
    telephone: false,
    water: false,
  },
  permitted_density: 0,
  postal_code: "",
  property_identification_number: "",
  proposed_project_description: "",
  rezoning: false,
  rezoning_application_filename: null,
  rezoning_community_plan_filename: null,
  servicing_agreement_filename: null,
  servicing_been_completed: true,
  servicing_community_plan_filename: null,
  site_area: "",
  site_plan_description: "",
  site_plans_filename: null,
  site_servicing_contract: false,
  site_servicing_contract_description: "",
  site_servicing_contract_filename: null,
  site_servicing_plan_description: "",
  site_servicing_plans_filename: null,
  state_or_province: "",
});
export const ProposedOverviewQueryKey = "proposed-overview";
const ProposedOverview = ({ onUpdate, opportunity }) => {
  const params = useParams();
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const { next } = useAccordionWizard();
  const { handleFileFields } = useFileUpload();
  const form = useForm({
    defaultValues: getProposedOverviewModel(),
  });
  const queryKey = [ProposedOverviewQueryKey, { id: params.id }];
  const { isLoading: fetchLoading } = useQuery({
    queryKey,
    queryFn: proposedProjectController.getOverview.bind(null, params.id),
    onSuccess: (data) => form.reset(merge(getProposedOverviewModel(), data)),
  });

  const handleUpdateOverview = async (values) => {
    return handleFileFields(values).then((values) => {
      values = removeEmptyValues(values);
      if (!values.state_or_province) values.state_or_province = "";
      return proposedProjectController.updateOverview({
        ...values,
        opportunityId: params.id,
        loanType: opportunity.loan_type,
      });
    });
  };

  const { isLoading: postLoading, mutate } = useMutation(handleUpdateOverview, {
    onSuccess: () => {
      showToast("Overview updated!", "success");
      queryClient.invalidateQueries(queryKey);
      next();
      onUpdate();
    },
  });

  return (
    <AccordionForm
      accordionTitle={"Project Overview"}
      accordionKey="overview"
      isPreLoading={fetchLoading}
      isPostLoading={postLoading}
      form={form}
      onSubmit={mutate}
    >
      <FormRenderer fields={proposedOverviewFields[opportunity.loan_type]} />
    </AccordionForm>
  );
};

export default ProposedOverview;
